/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceStoreLocation } from './SurfaceStoreLocation';
import {
    SurfaceStoreLocationFromJSON,
    SurfaceStoreLocationFromJSONTyped,
    SurfaceStoreLocationToJSON,
    SurfaceStoreLocationToJSONTyped,
} from './SurfaceStoreLocation';

/**
 * 
 * @export
 * @interface SurfaceStoreLocatorConfig
 */
export interface SurfaceStoreLocatorConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocatorConfig
     */
    heading?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocatorConfig
     */
    description?: string;
    /**
     * 
     * @type {Array<SurfaceStoreLocation>}
     * @memberof SurfaceStoreLocatorConfig
     */
    locations?: Array<SurfaceStoreLocation>;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStoreLocatorConfig
     */
    searchRadiusMiles?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocatorConfig
     */
    defaultView?: SurfaceStoreLocatorConfigDefaultViewEnum;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStoreLocatorConfig
     */
    maxResults?: number;
}


/**
 * @export
 */
export const SurfaceStoreLocatorConfigDefaultViewEnum = {
    map: 'map',
    list: 'list'
} as const;
export type SurfaceStoreLocatorConfigDefaultViewEnum = typeof SurfaceStoreLocatorConfigDefaultViewEnum[keyof typeof SurfaceStoreLocatorConfigDefaultViewEnum];


/**
 * Check if a given object implements the SurfaceStoreLocatorConfig interface.
 */
export function instanceOfSurfaceStoreLocatorConfig(value: object): value is SurfaceStoreLocatorConfig {
    return true;
}

export function SurfaceStoreLocatorConfigFromJSON(json: any): SurfaceStoreLocatorConfig {
    return SurfaceStoreLocatorConfigFromJSONTyped(json, false);
}

export function SurfaceStoreLocatorConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStoreLocatorConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'heading': json['heading'] == null ? undefined : json['heading'],
        'description': json['description'] == null ? undefined : json['description'],
        'locations': json['locations'] == null ? undefined : ((json['locations'] as Array<any>).map(SurfaceStoreLocationFromJSON)),
        'searchRadiusMiles': json['searchRadiusMiles'] == null ? undefined : json['searchRadiusMiles'],
        'defaultView': json['defaultView'] == null ? undefined : json['defaultView'],
        'maxResults': json['maxResults'] == null ? undefined : json['maxResults'],
    };
}

export function SurfaceStoreLocatorConfigToJSON(json: any): SurfaceStoreLocatorConfig {
    return SurfaceStoreLocatorConfigToJSONTyped(json, false);
}

export function SurfaceStoreLocatorConfigToJSONTyped(value?: SurfaceStoreLocatorConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heading': value['heading'],
        'description': value['description'],
        'locations': value['locations'] == null ? undefined : ((value['locations'] as Array<any>).map(SurfaceStoreLocationToJSON)),
        'searchRadiusMiles': value['searchRadiusMiles'],
        'defaultView': value['defaultView'],
        'maxResults': value['maxResults'],
    };
}

